import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { motion } from 'framer-motion';

import { Typo } from 'uikit/content';

import Card from './card';
import CardMedia from './cardMedia';
import CardMeta from './cardMeta';

import styles from '../styles/uikitCardsCardOverlay.module.scss';

const CardOverlay = ({
  className = '',
  image = null,
  // DEPRECATED - Use `to` for links
  link = '',
  // DEPRECATED
  meta = '',
  testId = '',
  text = '',
  title = '',
  to = '',
  isExternalLink = false,
}) => {
  const revealTransition = {
    type: 'tween',
    duration: 0.2,
  };
  const revealText = {
    rest: {
      opacity: 0,
      height: 0,
      transition: revealTransition,
    },
    hover: {
      opacity: 1,
      height: 'auto',
      transition: revealTransition,
    },
  };

  return (
    <Card
      className={classnames(styles.element, className)}
      testId={testId}
      to={to || link}
      isExternalLink={isExternalLink}
    >
      <motion.div
        animate="rest"
        className={styles.reveal}
        initial="rest"
        whileHover="hover"
      >
        <CardMedia
          image={image}
          mediaClassName={styles.figure}
          title={title}
        >
          <div className={styles.content}>
            <Typo
              className={styles.title}
              element="h3"
              variant="d01"
              weight="bold"
            >
              {title}
            </Typo>
            <motion.div className={styles.reveal} variants={revealText}>
              {text && (
                <div className={styles.text}>
                  <Typo element="span" variant="b01">{text}</Typo>
                </div>
              )}
              {meta && <CardMeta className={styles.meta} text={meta} />}
            </motion.div>
          </div>
        </CardMedia>
      </motion.div>
    </Card>
  );
};

CardOverlay.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  meta: PropTypes.string,
  testId: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
  isExternalLink: PropTypes.bool,
};

export default React.memo(CardOverlay);
